import type { Theme } from '@emotion/react';

type FontName = keyof Theme['fonts'];

function expandFonts(theme: Theme): Theme {
  const fontNames = Object.keys(theme.fonts);

  fontNames.forEach((fontName: string): void => {
    const font = theme.fonts[fontName as FontName];

    if (font) {
      const { base, ...rest } = font;

      if (base) {
        // TODO: baseFont does not exist on type 'Theme'
        // @ts-expect-error baseFont does not exist on type 'Theme' but it does, so expect an error
        const baseFont = theme.baseFonts[base];

        theme.fonts[fontName as FontName] = { ...baseFont, ...rest };
      }
    }
  });

  return theme;
}

export default expandFonts;
